import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

/**
 * Shared Sign in / Create account switcher for auth screens.
 */
const AuthModeTabs = ({ mode = 'login', onLogin, onRegister }) => (
  <Box sx={{ mb: 3 }} data-testid="auth-mode-tabs">
    <Tabs
      value={mode}
      onChange={(_event, next) => {
        if (next === 'login') onLogin?.();
        if (next === 'register') onRegister?.();
      }}
      variant="fullWidth"
      aria-label="Sign in or create account"
      sx={{
        minHeight: 44,
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.95rem',
          minHeight: 44,
        },
      }}
    >
      <Tab value="login" label="Sign in" id="auth-tab-login" aria-controls="auth-tabpanel-login" />
      <Tab
        value="register"
        label="Create account"
        id="auth-tab-register"
        aria-controls="auth-tabpanel-register"
      />
    </Tabs>
  </Box>
);

export default AuthModeTabs;
